import { useQuery } from "@tanstack/react-query";
import { useFeatureFlags } from "swing-components";

import { ExpiringDocumentsDetail, ExpiringDocumentsResponse, GET } from "~utils";

export function useExpiringDocuments() {
  const FOUR_HOURS_IN_MS = 1000 * 60 * 60 * 4;
  const { flags } = useFeatureFlags();
  const isExpiringV2 = flags.expiringDocumentBannerV2;

  return useQuery<ExpiringDocumentsResponse, Error, ExpiringDocumentsDetail>({
    queryKey: ["fetchExpiringDocuments", isExpiringV2],
    queryFn: () =>
      isExpiringV2
        ? GET("/api/sub/documents/expiring", {
            queryParams: {
              version: 2,
            },
          })
        : GET("/api/sub/documents/expiring"),
    staleTime: FOUR_HOURS_IN_MS,
    gcTime: FOUR_HOURS_IN_MS,
    select: (data: ExpiringDocumentsResponse) => {
      const expiringDocumentsData = data.data.expiringDocuments;

      if (typeof expiringDocumentsData === "boolean") {
        return {
          status: expiringDocumentsData ? "DOC_EXPIRED" : "DOC_VALID",
        };
      }

      return expiringDocumentsData;
    },
  });
}
